import { Dialog } from 'primereact/dialog'
import classes from './AddAttachmentRPLinkTestReportDialog.module.scss'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { useState } from 'react'
import { DataTable } from 'primereact/datatable'
import CertificateListService from '../../../../../../../../services/CertificateListService'
import { IAddAttachmentsRPTestReportModel } from '../../interfaces/IAddAttachmentsRPTestReportModel'
import { get } from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { Tooltip } from 'primereact/tooltip'
import clsx from 'clsx'

const AddAttachmentRPLinkTestReportDialog = (props: any) => {
  const { visible, onHide, setRPAttachments, rpAttachments } = props
  const [testReportDocuments, setTestReportDocuments] = useState<any>([])
  const [originalTestReportDocuments, setOriginalTestReportDocuments] = useState<any>([])
  const [selected, setSelected] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [searchValue, setSearchValue] = useState({
    referenceNumber: '',
    certificateNumber: '',
    ecmNodeId: '',
  })

  const columns = [
    { field: 'ecmFileName', header: 'Document File Name', width: '70px' },
    { field: 'ecmFileNodeId', header: 'ECM Node ID', width: '50px' },
    { field: 'certificateNumber', header: 'Certificate Number', width: '70px' },
    { field: 'referenceNumber', header: 'Reference Number', width: '70px' },
    { field: 'message', header: '', width: '50px' },
  ]

  const headerComponent = 'Link Test Report from ECM'

  const handleCloseModal = () => {
    setSearchValue({
      referenceNumber: '',
      certificateNumber: '',
      ecmNodeId: '',
    })
    setTestReportDocuments([])
    setSelected([])
    onHide()
  }

  const tableColumnBody = (rowData: any, col: any) => {
    return (
      <div
        title={get(rowData, col.field)}
        className={clsx(classes['table-column'], 'text-container-ellipsis')}
      >
        {get(rowData, col.field)}
      </div>
    )
  }

  const messageColumnBody = (rowData: any, col: any) => {
    const ecmNodeId = rowData.ecmFileNodeId
    const isLinked = rpAttachments.find((x: any) => x.ecmFileNodeId === ecmNodeId)
    const message = isLinked ? 'Test Report is already linked in the attachments section' : ''

    return (
      <div title={message} className={clsx(classes['message-column'], 'text-container-ellipsis')}>
        <i>{message}</i>
      </div>
    )
  }

  const validationIfSelectable = (rowData: any) => {
    const ecmNodeId = rowData.ecmFileNodeId
    const isLinked = rpAttachments.some((attachment: any) => attachment.ecmFileNodeId === ecmNodeId)

    return !isLinked
  }

  const certificateNumberColumnBody = (rowData: any, col: any) => {
    const certificateNumbers = originalTestReportDocuments
      .filter(
        (x: any) =>
          x.ecmFileNodeId === rowData.ecmFileNodeId &&
          x.certificateNumber !== rowData.certificateNumber
      )
      .map((x: any) => x.certificateNumber)

    return (
      <div className={clsx(classes['certificate-number-column'], 'text-container-ellipsis')}>
        {get(rowData, col.field)}

        {certificateNumbers?.length > 0 && (
          <span className={`file-${rowData.ecmFileNodeId}`}>
            <FontAwesomeIcon icon={faCircleInfo} size="xs" />

            <Tooltip target={`.file-${rowData.ecmFileNodeId}`} position="right">
              {certificateNumbers.join('\n')}
            </Tooltip>
          </span>
        )}
      </div>
    )
  }

  const processColumnBodyTemplates = (col: any) => {
    if (col.field === 'certificateNumber') return certificateNumberColumnBody.bind(col)
    else if (col.field === 'message') return messageColumnBody.bind(col)

    return tableColumnBody.bind(col)
  }

  const dynamicColumns = columns.map((col, i) => {
    return (
      <Column
        key={col.field}
        field={col.field}
        header={col.header}
        body={processColumnBodyTemplates(col)}
        style={{ width: col.width }}
      />
    )
  })

  const onChangeSearchValue = (e: any, field: string) => {
    if (field === 'referenceNumber') {
      setSearchValue({
        referenceNumber: e.target.value,
        certificateNumber: '',
        ecmNodeId: '',
      })
    } else if (field === 'certificateNumber') {
      setSearchValue({
        referenceNumber: '',
        certificateNumber: e.target.value,
        ecmNodeId: '',
      })
    } else if (field === 'ecmNodeId') {
      setSearchValue({
        referenceNumber: '',
        certificateNumber: '',
        ecmNodeId: e.target.value,
      })
    }
  }

  const searchDocument = async () => {
    setIsLoading(true)
    setSelected([])
    var testReport = await CertificateListService.getCertificateTestReportDocument(searchValue)

    if (testReport?.data) {
      const result = testReport.data
      const uniqueTestReport = Array.from(
        new Map(result.map((item: any) => [item.ecmFileNodeId, item])).values()
      )

      setTestReportDocuments(uniqueTestReport)
      setOriginalTestReportDocuments(testReport.data)
    } else {
      setTestReportDocuments([])
      setOriginalTestReportDocuments([])
    }

    setIsLoading(false)
  }

  const handleSearchInputEnter = (e: any) => {
    if (e.key === 'Enter') {
      if (
        searchValue.certificateNumber === '' &&
        searchValue.referenceNumber === '' &&
        searchValue.ecmNodeId === ''
      )
        return

      searchDocument()
    }
  }

  const handleLinkTestReport = () => {
    const mappedData = selected.map((data: any) => {
      let mapped: IAddAttachmentsRPTestReportModel = {
        id: data.id,
        documentFileName: data.ecmFileName,
        projectNumber: data.projectNumber,
        contentGroup: data.contentGroup,
        issueDate: data.issueDate,
        type: data.type,
        reportNumber: data.reportNumber,
        referenceNumber: data.referenceNumber,
        standardNumber: data.standardNumber,
        isValid: true,
        fileResult: 'This Test Report already exists in ECM TIC',
        revisionNumber: data.revisionNumber,
        fileNumber: data.fileNumber,
        ecmFileNodeId: data.ecmFileNodeId,
        file: null,
        status: data.status,
        ecmFileName: data.ecmFileName,
        isToLinkTestReport: true,
        supportingDocuments: [],
      }
      return mapped
    })

    setRPAttachments((prevState: any) => {
      const newState = [...prevState, ...mappedData]
      return newState
    })

    handleCloseModal()
  }

  const footerComponent = (
    <div className={classes['link-test-report-footer']}>
      <div className={classes['link-test-report-footer-btns']}>
        <Button
          label="CANCEL"
          className={classes['default-cancel-button']}
          onClick={handleCloseModal}
        />
        <Button
          label="LINK TEST REPORT"
          className={classes['default-save-button']}
          onClick={() => handleLinkTestReport()}
          disabled={selected?.length === 0}
        />
      </div>
    </div>
  )

  return (
    <>
      <Dialog
        className={classes['link-test-report-dialog']}
        visible={visible}
        onHide={handleCloseModal}
        header={headerComponent}
        footer={footerComponent}
      >
        <div className={classes['link-test-report-body']}>
          <div className={classes['link-test-report-search']}>
            <div className={classes['input-component']}>
              <div className={classes['input-label']}>Reference Number</div>
              <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText
                  value={searchValue.referenceNumber}
                  onKeyDown={handleSearchInputEnter}
                  placeholder="Type and press 'Enter'"
                  onChange={(e: any) => {
                    onChangeSearchValue(e, 'referenceNumber')
                  }}
                />
              </span>
            </div>

            <div className={classes['input-component']}>
              <div className={classes['input-label']}>Certificate Number</div>
              <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText
                  value={searchValue.certificateNumber}
                  onKeyDown={handleSearchInputEnter}
                  placeholder="Type and press 'Enter'"
                  onChange={(e: any) => {
                    onChangeSearchValue(e, 'certificateNumber')
                  }}
                />
              </span>
            </div>

            <div className={classes['input-component']}>
              <div className={classes['input-label']}>ECM Node ID</div>
              <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText
                  value={searchValue.ecmNodeId}
                  onKeyDown={handleSearchInputEnter}
                  placeholder="Type and press 'Enter'"
                  onChange={(e: any) => {
                    onChangeSearchValue(e, 'ecmNodeId')
                  }}
                />
              </span>
            </div>
          </div>

          <br />

          <div className={classes['link-test-report-table-wrapper']}>
            <div className={classes['test-report-selected-count']}>
              <b>({selected?.length}) Test Report selected</b>
            </div>
            <div className={classes['wrapper']}>
              <DataTable
                value={testReportDocuments}
                responsiveLayout="scroll"
                scrollable
                scrollHeight="flex"
                loading={isLoading}
                selection={selected}
                onSelectionChange={(e: any) => setSelected(e.value)}
                dataKey="id"
                isDataSelectable={(e: any) => validationIfSelectable(e.data)}
              >
                <Column
                  style={{ width: '50px', maxWidth: '50px' }}
                  selectionMode="multiple"
                  bodyClassName={(e: any) => {
                    return !validationIfSelectable(e) ? classes['checkbox-disabled'] : ''
                  }}
                />
                {dynamicColumns}
              </DataTable>
            </div>
          </div>

          <div className={classes['link-test-report-footer-note']}>
            <div>
              <b>Note:</b>
            </div>
            <span className={classes['note']}>
              For documents saved via GMAWB, you may search by the Reference Number, Certificate
              Number or ECM Node ID.
            </span>
            <span className={classes['note']}>
              For documents saved outside of GMAWB (e.g., BBP or other ECM tools), search using the
              ECM Node ID only
            </span>
          </div>
        </div>
      </Dialog>
    </>
  )
}

export default AddAttachmentRPLinkTestReportDialog
